// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DevPostalAddressController {
	constructor() {
		this.data = undefined;
		this.postalAddressOptions = {
			defaults: {
				country: [{ kid: 'K_NODE;FRANCE', name: 'France (Europe)' }],
			},
		};
		this.readOnly = false;
		this.required = false;
	}
}
